import { useState, useEffect, useContext, useCallback } from "react";
import { MainContext } from "../../context/main-context";
import { reFormatFields } from "../use-func/tranform-jetstream";
import {
    getVoList,
    getStorageList,
    getStorageFieldsList,
    getLastObjectList
} from "../../api/andaman/jetstream";


export const UseVoListA = () => {
    const [voList, setvoList] = useState<object | null>(null);
    const { hostA, tokenA } = useContext(MainContext);

    const loadVo = useCallback(async () => {
        let volist = new Array();
        const rsVolist = await getVoList(hostA, tokenA);
        volist = rsVolist;
        setvoList(volist);
    }, [tokenA]);

    useEffect(() => {
        if (!voList && hostA && tokenA) {
            loadVo();
        }
    }, [voList, hostA, tokenA]);

    return voList;
};

export const UseStorageListA = (vo: string) => {
    const [storageList, setstorageList] = useState<object | null>(null);
    const { hostA, tokenA } = useContext(MainContext);

    const loadVo = useCallback(async () => {
        let storagelist = new Array();
        const rsStoragelist = await getStorageList(hostA, tokenA, vo);
        storagelist = rsStoragelist;
        setstorageList(storagelist);
    }, [tokenA]);

    useEffect(() => {
        if (!storageList) {
            loadVo();
        }
    }, [storageList]);

    return storageList;
};

export const UseCallbackStorageListA = async (
    host: string,
    token: string,
    vo: string
) => {
    const rsStoragelist = await getStorageList(host, token, vo);
    return rsStoragelist;
};

export const UseStorageFieldsA = (vo: string, storage: string) => {
    const [fields, setfields] = useState<object | null>(null);
    const { hostA, tokenA } = useContext(MainContext);

    const loadVo = useCallback(async () => {
        let Fields: any = new Array();
        const rsFields = await getStorageFieldsList(hostA, tokenA, vo, storage);
        Fields = rsFields.length > 0 ? await reFormatFields(rsFields) : [];
        setfields(Fields);
    }, [tokenA]);

    useEffect(() => {
        if (!fields) {
            loadVo();
        }
    }, [fields]);

    return fields;
};

export const UseCallbackStorageFieldsA = async (
    host: string,
    token: string,
    vo: string,
    storage: string
) => {
    let Fields: any = new Array();
    const rsFields = await getStorageFieldsList(host, token, vo, storage);
    Fields = rsFields.length > 0 ? await reFormatFields(rsFields) : [];

    return Fields;
};

export const UseLastObjectsA = (vo: string, storage: string, limit: number) => {
    const [objs, setobjs] = useState<object | null>(null);
    const { hostA, tokenA } = useContext(MainContext);

    const loadVo = useCallback(async () => {
        const rsFields = await getLastObjectList(hostA, tokenA, vo, storage, limit);

        setobjs(rsFields);
    }, [tokenA]);

    useEffect(() => {
        if (!objs) {
            loadVo();
        }
    }, [objs]);

    return objs;
};

export const UseCallbackLastObjectA = async (
    hostA: string,
    tokenA: string,
    vo: string,
    storage: string,
    limit: number
) => {
    const rs = await getLastObjectList(
        hostA,
        tokenA,
        vo,
        storage,
        limit ? limit : 10
    );
    return rs;
};
